/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ImageHelper, IMediaModel } from "@bms/common";

import { ImageWithPlaceholder } from "components/ImageWithPlaceholder";
import resources from "resources/list";

import "./MatchLeagueInfo.scss";

type IMatchLeagueInfoProps = {
  media?: IMediaModel;
};

export const MatchLeagueInfo = ({ media }: IMatchLeagueInfoProps) => {
  if (!media || !media.Match || !media.Match?.League) {
    return null;
  }

  const league = media.Match?.League;

  if (!league) {
    return null;
  }

  const teamLogo = ImageHelper.getSquareImage(league?.Images);

  return (
    <div className="match-league-info">
      <ImageWithPlaceholder
        imageData={teamLogo}
        imageContainerClassName="match-league-info__image-container"
        imageClassName="match-league-info__image"
        placeholderSrc={resources.squarePlaceholder}
        placeholderClassName="match-league-info__placeholder"
        disableAbsolutePosition
      />
      <div className="match-league-info__name">{league.Name}</div>
    </div>
  );
};
